import React from 'react';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { KeyRound, RefreshCw } from 'lucide-react';

export default function OtpStep({
  email, otp, setOtp, loading,
  resendCooldown, resendCount,
  onSubmit, onResend, onBack,
}) {
  const resendDisabled = loading || resendCooldown > 0 || resendCount >= 3;
  let resendLabel;
  if (resendCooldown > 0) resendLabel = `Resend in ${resendCooldown}s`;
  else if (resendCount >= 3) resendLabel = 'Max resends reached';
  else resendLabel = 'Resend Code';

  return (
    <div className="space-y-5" data-testid="forgot-otp-step">
      <div className="bg-emerald-50 border border-emerald-200 rounded-xl p-4 mb-6">
        <div className="flex items-start gap-3">
          <KeyRound className="w-5 h-5 text-emerald-600 mt-0.5" />
          <div>
            <p className="text-sm font-semibold text-emerald-900">Check your email</p>
            <p className="text-xs text-emerald-700 mt-1">
              We sent a 5-digit code to <span className="font-semibold">{email}</span>
            </p>
          </div>
        </div>
      </div>

      <form onSubmit={onSubmit} className="space-y-5">
        <div>
          <Label htmlFor="reset-otp-input" className="uppercase text-xs font-bold text-muted-foreground mb-1.5 block">
            Verification Code
          </Label>
          <div className="relative">
            <KeyRound className="absolute left-4 top-1/2 -translate-y-1/2 w-5 h-5 text-muted-foreground" />
            <Input
              id="reset-otp-input"
              data-testid="reset-otp-input"
              type="text"
              inputMode="numeric"
              pattern="[0-9]*"
              maxLength={5}
              placeholder="12345"
              value={otp}
              onChange={(e) => setOtp(e.target.value.replace(/\D/g, ''))}
              className="h-14 rounded-2xl bg-secondary border-transparent pl-12 text-center text-2xl tracking-widest font-bold"
              required
              autoFocus
            />
          </div>
        </div>

        <Button
          type="submit"
          data-testid="verify-reset-otp-button"
          className="w-full btn-volt h-14"
          disabled={loading || otp.length !== 5}
        >
          {loading ? 'Verifying...' : 'Verify Code'}
        </Button>
      </form>

      <div className="flex items-center justify-center gap-2 pt-2">
        <Button
          type="button"
          variant="ghost"
          onClick={onResend}
          disabled={resendDisabled}
          className="text-sm"
          data-testid="resend-reset-otp-button"
        >
          <RefreshCw className="w-4 h-4 mr-2" />
          {resendLabel}
        </Button>
      </div>

      {resendCount > 0 && resendCount < 3 && (
        <p className="text-xs text-center text-muted-foreground">Resent {resendCount}/3 times</p>
      )}

      <div className="pt-4 border-t">
        <Button type="button" variant="ghost" onClick={onBack} className="w-full text-sm" data-testid="forgot-back-to-login-button">
          ← Back to Login
        </Button>
      </div>
    </div>
  );
}
